<mapv2-sectors *ngIf="map && map.imageSectors"></mapv2-sectors>